import { Layout as AntLayout } from 'antd';
import Header from './header';
import VerdentraLogo from '../assets/verdentra.svg';
import { Outlet } from 'react-router-dom';

const { Footer, Content } = AntLayout;

const Layout = () => {
  return (
    <AntLayout className="min-h-[100vh]">
      <div className="sticky top-0 h-[48px] z-[999]">
        <Header />
      </div>
      <Content className="px-[10px]">
        <Outlet />
      </Content>
      <Footer className="h-[45px] px-[10px] py-0 flex items-center justify-start bg-[#003568]">
        <img src={VerdentraLogo} alt="verdentra-logo" />
      </Footer>
    </AntLayout>
  );
};

export default Layout;
